export const fileActionTypes = {
  UPLOAD_FILES: '@file/UPLOAD_FILES',
  UPLOAD_FILES_START: '@file/UPLOAD_FILES_START',
  UPLOAD_FILES_ERROR: '@file/UPLOAD_FILES_ERROR',

  DELETE_FILE: '@file/DELETE_FILE',
  DELETE_FILE_START: '@file/DELETE_FILE_START',
  DELETE_FILE_ERROR: '@file/DELETE_FILE_ERROR',

  UPLOAD_AVATAR: '@file/UPLOAD_AVATAR',
  UPLOAD_AVATAR_START: '@file/UPLOAD_AVATAR_START',
  UPLOAD_AVATAR_ERROR: '@file/UPLOAD_AVATAR_ERROR',
};
